export class Event {
  public _id:String;
  public title: String;
  public description:String;
  public image:String;
  public nbParticipant:String;
  public date:Date;
  constructor(){}
}
